'use client';

import { useEffect, useState } from 'react';
import { useProfileData } from '../queries/useProfileQueries';
import { REDUCED_MOTION_QUERY, watchMediaQuery } from '../lib/browserSurface';


export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => watchMediaQuery(REDUCED_MOTION_QUERY, setReduced), []);

  return reduced;
}

export function useUiMotionEnabled(): boolean {
  return !usePrefersReducedMotion();
}

export function useGameMotionEnabled(): boolean {
  const profile = useProfileData();

  return profile?.animationsEnabled ?? true;
}
